/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container-fluid[_ngcontent-%COMP%]{width:100%;min-height:50%;padding-right:0;padding-left:0}"];
export { styles as styles };
